/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuoteTestExecutionState {
  Approved = "approved",
  Rejected = "rejected",
  Pending = "pending",
}

export function instanceOfQuoteTestExecutionState(value: any): boolean {
  for (const key in QuoteTestExecutionState) {
    if (Object.prototype.hasOwnProperty.call(QuoteTestExecutionState, key)) {
      if (
        QuoteTestExecutionState[key as keyof typeof QuoteTestExecutionState] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuoteTestExecutionStateFromJSON(
  json: any,
): QuoteTestExecutionState {
  return QuoteTestExecutionStateFromJSONTyped(json, false);
}

export function QuoteTestExecutionStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionState {
  return json as QuoteTestExecutionState;
}

export function QuoteTestExecutionStateToJSON(
  value?: QuoteTestExecutionState | null,
): any {
  return value as any;
}

export function QuoteTestExecutionStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionState {
  return value as QuoteTestExecutionState;
}
